import React, {FC} from 'react';

import {RuleEditorPanelId} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {SettingsRuleResourcePagesEnum} from '../../models/url/models/rulesUrlModel';
import {SettingsRootPagesEnum} from '../../models/url/models/types';
import {
  SettingsWorkflowsEditUrl,
  SettingsWorkflowsResourcePagesEnum,
} from '../../models/url/models/workflowsUrlModel';
import {RuleEditorWrapper} from '../../settings/rules/ruleEditorWrapper';
import {RuleIntegration} from '../../settings/rules/ruleIntegrationModel';
import {RuleIntegrationWrapper} from '../../settings/rules/ruleIntegrationWrapper';
import {WorkflowEditorWrapper} from '../../settings/workflows/editor/workflowEditorWrapper';
import {RuleEditorPanelState} from '../../store/panels/ruleEditor/ruleEditorPanelState';
import {Frame} from '../common/frames/frame';

interface PopupRuleEditorProps extends RuleEditorPanelState {
  panelId: RuleEditorPanelId;
  onRequestClose: () => void;
}

export const PopupRuleEditor: FC<PopupRuleEditorProps> = ({panelId, onRequestClose, ...panel}) => (
  <Frame
    width={900}
    height={1000}
    shouldForcePopout
    onRequestClose={onRequestClose}
    interactionId="popup-rule-editor"
  >
    <RuleIntegrationWrapper>
      {(ruleIntegration) => renderRuleEditor(panelId, panel, ruleIntegration)}
    </RuleIntegrationWrapper>
  </Frame>
);

function renderRuleEditor(
  panelId: RuleEditorPanelId,
  panel: RuleEditorPanelState,
  ruleIntegration: RuleIntegration,
) {
  const {isWorkflow, ruleId, ruleBundleId, ruleNamespace} = panel;

  if (isWorkflow) {
    const url: SettingsWorkflowsEditUrl = {
      rootPage: SettingsRootPagesEnum.WORKFLOWS,
      workflowId: ruleBundleId,
      resourcePage: SettingsWorkflowsResourcePagesEnum.EDIT,
      namespace: ruleNamespace,
    };

    return <WorkflowEditorWrapper url={url} panelId={panelId} ruleIntegration={ruleIntegration} />;
  }

  return (
    <RuleEditorWrapper
      ruleIntegration={ruleIntegration}
      panelId={panelId}
      resourcePage={SettingsRuleResourcePagesEnum.EDIT}
      ruleId={ruleId}
      bundleId={ruleBundleId}
      namespace={ruleNamespace}
      breadcrumbs={[]}
    />
  );
}
